export default {
  default: () => import("/builds/bounsel/flow/frontend/app-flow/apps/editor/layouts/default.vue").then(m => m.default || m),
  error: () => import("/builds/bounsel/flow/frontend/app-flow/apps/editor/layouts/error.vue").then(m => m.default || m),
  full: () => import("/builds/bounsel/flow/frontend/app-flow/apps/editor/layouts/full.vue").then(m => m.default || m)
}